/// *** System import ***///
import { Injectable, Inject } from '@angular/core';
import { Events, ToastController } from 'ionic-angular';
import { Http, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { deepCopy } from 'ionic-angular/util/util';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../app/globals';
import { EnvVariables } from '../../app/environment-variables/environment-variables.token';
import { SessionProvider } from '../session';

@Injectable()
export class TradingProcessProvider {
  constructor(
    // *** System
    private events: Events,
    private http: Http,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    @Inject(EnvVariables) private envVariables,
    private session: SessionProvider) {
  }

  // *** Annuler un ordre en bourse
  public cancelOrder(orderID: string) {
    return new Promise((resolve, reject) => {
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let options = new RequestOptions({ headers: requestHeaders });
      let requestBody = {
        UserID: this.session.data.userID,
        TradingOrderID: orderID
      };
      this.http.post(this.envVariables.process_cancelTradingOrder_url, requestBody, options).map(res => res.json()).subscribe(
        (data) => { resolve(); },
        (error) => {
          let msg = JSON.parse(error._body).Message;
          console.log(msg);
          this.globals.showError(this.toastCtrl, msg);
          reject();
        }
      );
    });
  }

  // *** Valider un ordre en bourse
  public validateOrder(isNew: boolean, order: any) {
    return new Promise((resolve, reject) => {
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let options = new RequestOptions({ headers: requestHeaders });
      let requestBody = {
        UserID: this.session.data.userID,
        IsNew: isNew,
        Order: order
      };
      this.http.post(this.envVariables.process_validateTradingOrder_url, requestBody, options).map(res => res.json()).subscribe(
        (data) => { resolve(data); },
        (error) => {
          let msg = JSON.parse(error._body).Message;
          console.log(msg);
          this.globals.showError(this.toastCtrl, msg);
          reject();
        }
      );
    });
  }

  // *** Ajouter un ordre en bourse
  public addOrder(order: any) {
    return new Promise((resolve, reject) => {
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let options = new RequestOptions({ headers: requestHeaders });
      let requestBody = {
        UserID: this.session.data.userID,
        Order: order
      };
      this.http.post(this.envVariables.process_addTradingOrder_url, requestBody, options).map(res => res.json()).subscribe(
        (data) => { resolve(data); },
        (error) => {
          let msg = JSON.parse(error._body).Message;
          console.log(msg);
          this.globals.showError(this.toastCtrl, msg);
          reject();
        }
      );
    });
  }

  // *** Modifier un ordre en bourse
  public updateOrder(order: any) {
    return new Promise((resolve, reject) => {
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let options = new RequestOptions({ headers: requestHeaders });
      let requestBody = {
        UserID: this.session.data.userID,
        Order: order
      };
      this.http.post(this.envVariables.process_updateTradingOrder_url, requestBody, options).map(res => res.json()).subscribe(
        (data) => { resolve(data); },
        (error) => {
          let msg = JSON.parse(error._body).Message;
          console.log(msg);
          this.globals.showError(this.toastCtrl, msg);
          reject();
        }
      );
    });
  }
}


// WEBPACK FOOTER //
// ./src/providers/processes/trading.ts